import LabelOne from "../mockData/images/labels/1.png"
import LabelTwo from "../mockData/images/labels/2.png"
import LabelThree from "../mockData/images/labels/3.png"
import LabelFour from "../mockData/images/labels/4.png"
import LabelFive from "../mockData/images/labels/5.png"
import LabelSix from "../mockData/images/labels/6.png"
import LabelSeven from "../mockData/images/labels/7.png"
import LabelEight from "../mockData/images/labels/8.png"
import LabelNine from "../mockData/images/labels/9.png"
import LabelTen from "../mockData/images/labels/10.png"

const mockLabelsData = [
{
    "id": 1,
    "name": "Midnight Melodies Co.",
    "logo": LabelOne,
    "promo_graphic": {},
    "company": "ABC Company GmbH",
    "contract_received": true,
    "information_accepted": true,
    "label_approved": true,
    "beatport_approved": true,
    "traxsource_approved": true,
    "owner": "John Doe"
},
{
    "id": 2,
    "name": "Harmonic Fusion Records",
    "logo": LabelTwo,
    "promo_graphic": {},
    "company": "ABC Company GmbH",
    "contract_received": true,
    "information_accepted": true,
    "label_approved": true,
    "beatport_approved": true,
    "traxsource_approved": false,
    "owner": "John Doe"
},
{
    "id": 3,
    "name": "Retro Rhythms Music",
    "logo": LabelThree,
    "promo_graphic": {},
    "company": "ABC Company GmbH",
    "contract_received": true,
    "information_accepted": true,
    "label_approved": true,
    "beatport_approved": false,
    "traxsource_approved": true,
    "owner": "John Doe"
},
{
    "id": 4,
    "name": "Bassline Bridge Studios",
    "logo": LabelFour,
    "promo_graphic": {},
    "company": "ABC Company GmbH",
    "contract_received": true,
    "information_accepted": true,
    "label_approved": true,
    "beatport_approved": true,
    "traxsource_approved": true,
    "owner": "John Doe"
},
{
    "id": 5,
    "name": "Orbitwave Audio",
    "logo": LabelFive,
    "promo_graphic": {},
    "company": "ABC Company GmbH",
    "contract_received": true,
    "information_accepted": true,
    "label_approved": true,
    "beatport_approved": true,
    "traxsource_approved": false,
    "owner": "John Doe"
},
{
    "id": 6,
    "name": "Lyrical Landslide Records",
    "logo": LabelSix,
    "promo_graphic": {},
    "company": "ABC Company GmbH",
    "contract_received": true,
    "information_accepted": true,
    "label_approved": true,
    "beatport_approved": false,
    "traxsource_approved": false,
    "owner": "John Doe"
},
{
    "id": 7,
    "name": "Pulsepoint Productions",
    "logo": LabelSeven,
    "promo_graphic": {},
    "company": "ABC Company GmbH",
    "contract_received": false,
    "information_accepted": false,
    "label_approved": false,
    "beatport_approved": false,
    "traxsource_approved": false,
    "owner": "John Doe"
},
{
    "id": 8,
    "name": "Riff Radiance Music",
    "logo": LabelEight,
    "promo_graphic": {},
    "company": "ABC Company GmbH",
    "contract_received": false,
    "information_accepted": false,
    "label_approved": false,
    "beatport_approved": false,
    "traxsource_approved": false,
    "owner": "John Doe"
},
{
    "id": 9,
    "name": "Symphony Spectrum Studios",
    "logo": LabelNine,
    "promo_graphic": {},
    "company": "ABC Company GmbH",
    "contract_received": false,
    "information_accepted": false,
    "label_approved": false,
    "beatport_approved": false,
    "traxsource_approved": false,
    "owner": "John Doe"
},
{
    "id": 10,
    "name": "Vivid Vibes Entertainment",
    "logo": LabelTen,
    "promo_graphic": {},
    "company": "ABC Company GmbH",
    "contract_received": false,
    "information_accepted": false,
    "label_approved": false,
    "beatport_approved": false,
    "traxsource_approved": false,
    "owner": "John Doe"
}
];

export default mockLabelsData;